/**
* @providesModule SKZGameMode
*/
import SKZTournament from 'SKZTournament';

interface SKZGameModeRecord {
  id: string;
  name: string;
  mode_rules_markdown: string;
  background_image_url: string;
  tournaments: SKZTournament[];
}

class SKZGameMode {
  id: string;
  name: string;
  mode_rules_markdown: string;
  background_image_url: string;
  tournaments: SKZTournament[];

  constructor(gameMode: SKZGameModeRecord) {
    this.id = gameMode.id;
    this.name = gameMode.name;
    this.mode_rules_markdown = gameMode.mode_rules_markdown;
    this.background_image_url = gameMode.background_image_url;
    this.tournaments = gameMode.tournaments?.map((tournament) => new SKZTournament(tournament)) ?? null;
  }
  
  isCashAndZTournamentsAvailable(): boolean {
    const hasCash = this.tournaments.some((tournament) => tournament.isCashTournament());
    const hasZ = this.isZTournamentsAvailable();
    return hasCash && hasZ;
  }

  isZTournamentsAvailable(): boolean {
    return this.tournaments.some((tournament) => tournament.isZTournament());
  }
}

export {
  SKZGameModeRecord,
  SKZGameMode,
};
